export default __webpack_public_path__ + "static/media/processing.878ba784.svg";